import { useAppDispatch, useAppSelector } from 'app/state'
import { showGlobalBuilderError } from 'features/builder/state/builderSlice'
import { useTakeOverMutation } from 'features/builder/hooks/collaboration'
import { ResourceType } from 'features/common'
import { TakeOverResult } from 'features/collaboration/types'
import TakeOverRequestDialog from 'features/collaboration/ui/takeOver/TakeOverRequestDialog'

export type BuilderTakeOverRequestDialogProps = {
  open: boolean
  mode: 'forced' | 'userRequest'
  onFinished: (result: TakeOverResult) => void
}

function BuilderTakeOverRequestDialog({ open, mode, onFinished }: BuilderTakeOverRequestDialogProps) {
  const dispatch = useAppDispatch()
  const currentMapLockStatus = useAppSelector((state) => state.builder.currentMapLockStatus)
  const { mutateAsync: requestTakeOverAndLock, cancel: cancelTakeover, isLoading: isTakingOver } = useTakeOverMutation()

  const handleTakeOver = async () => {
    try {
      onFinished(await requestTakeOverAndLock())
    } catch (error) {
      dispatch(showGlobalBuilderError(String(error)))
      onFinished('cancel')
    }
  }

  const handleCancelTakeOver = () => {
    cancelTakeover()
    onFinished('cancel')
  }

  return (
    <TakeOverRequestDialog
      resourceType={ResourceType.Map}
      open={open}
      mode={mode}
      isTakingOver={isTakingOver}
      onTakeOver={handleTakeOver}
      onCancel={handleCancelTakeOver}
      user={currentMapLockStatus?.email}
    />
  )
}

export default BuilderTakeOverRequestDialog
